// extracted by mini-css-extract-plugin
export var contentBody = "_b4-9";
export var headerImage = "_b4-2";
export var imageButton = "_b4-7";
export var imageButtonIcon = "_b4-8";
export var imageHeader = "_b4-4";
export var imageHeaderText = "_b4-5";
export var imageOverlay = "_b4-3";
export var imageTitle = "_b4-6";
export var imageWrapper = "_b4-1";
export var taskList = "_b4-a";
export var widget = "_b4-0";